module.exports = __webpack_public_path__ + "static/BOQ-98df2eca1ebd050eb196345cb7b00bec.png";